import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import '../../assets/stylesheets/ProfileSlide/ProfilePage.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getGlobalAccount, getGlobalAccountAvatar } from "../../store/selectors";
import Avatar from '../Units/Avatar';
import { openDialog } from '../../store/actionCreators/dialog';

const popupButtons = ['support', 'about', 'tutorial', 'settings'];

const Profile = () => {
    const { t } = useTranslation();
    const globalAccount = useSelector(getGlobalAccount);
    const profileAvatar = useSelector(getGlobalAccountAvatar);
    const dispatch = useDispatch();

    const handleRowClick = (e, option) => {
        if (!!rowSpecialFns[option]) {
            e.preventDefault();
            rowSpecialFns[option]();
        }
    };
    const rowSpecialFns = {
        tutorial: () => dispatch(openDialog('comingSoon', { title: 'tutorial', val: 'Tutorials', smallSize: true }))
    };

    return (
        <div className={`profile`}>
            <div className={'avatar-container'}>
                <div className="avatar-block">
                    <Link to={'/profile/edit'} className={`avatar-wrapper`}>
                        <div className={`avatar-main`}>
                            <Avatar data={profileAvatar} isIncrementedFrame />
                        </div>
                        {/* <button className={'language-choice'} /> */}
                        {/* Will be used later */}
                        <div className="editPencil"></div>
                    </Link>
                </div>
                <div className={'profile-general'}>
                    <span className={'profile-username'}>{globalAccount.username}</span>
                    <div className="userid-container">
                        <span className={'profile-userid'}>{t('userId')} {globalAccount.id}</span>
                    </div>
                </div>
            </div>
            {/* <div className="progressBarContainer">
                <div className="rectangle"></div>
                <div className="textContainer">
                    <span>Account Level 4</span>
                    <span>XP Bar</span>
                </div>
                <Link to={`/accountlevel`}>
                    <div className="progressBar"><ProgressBar now={100}  /></div>
                </Link>
            </div> */}

            <div className={'profile-buttons'}>
                {
                    popupButtons.map(popupButton => (<div key={popupButton} className={popupButton}>
                        {
                            <Link to={popupButton} className={`profileLink`} onClick={e => handleRowClick(e, popupButton)}>
                                <span className={`${popupButton}-button`}></span>
                                <span className={`${popupButton}-label`}>{popupButton === 'about' ? t('aboutUs') : popupButton}</span>
                            </Link>
                        }
                    </div>))
                }
            </div>
        </div>
    )
};

export default Profile;
